import styled from "styled-components";
import { Button, Tabs } from "react-bootstrap";

const StyledScheduleContainer = styled.div`
    width: ${(props) => props.theme.width};
    height: 736px;
    background: #ffffff;
    border: 1px solid #f0f2f2;
    border-radius: 0px 8px 8px 0px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 10%);
    position: relative;
    @media (min-width: 1270px) {
        width: 800px;
    }
    @media (min-width: 1439px) {
        width: 75%;
    }
    @media (min-width: 2559px) {
        width: 86%;
    }
`;

const StyledTitleContainer = styled.h1`
    font-size: 16px;
    line-height: 150%;
    color: #404040;
`;

const StyledLegendTitle = styled.h1`
    font-size: 17px;
    font-weight: 400;
    margin: 10px 0 0 20px;
`;

const StyledBacklogTitle = styled.h2`
    font-size: 24px;
    font-weight: bold;
    color: #333;

    @media (max-width: 768px) {
        font-size: 20px;
    }

    @media (max-width: 480px) {
        font-size: 16px;
        text-align: center;
    }
`;

const StyledBacklogPhrase = styled.p`
    font-size: 14px;
    color: #404040;
    font-weight: 400;
    margin: 0;
`;

const StyledDateButton = styled.div`
    display: flex;
    align-items: center;
    position: absolute;
    left: 56%;
    padding-top: 18px;
    display: none/block;
    @media (min-width: 1270px) {
        left: 50%;
    }
    @media (min-width: 1400px) {
        left: 40%;
    }
    @media (min-width: 1730px) {
        left: 35%;
    }
    @media (min-width: 2000px) {
        left: 30%;
    }
    @media (min-width: 2559px) {
        left: 26%;
    }
`;

const StyledModalLegend = styled.div`
    width: 400px;
    height: 400px;
    background: #ffffff;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    border-radius: 2px;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    align-content: center;
    z-index: 10;
`;

const StyledSquareLegend = styled.div`
    width: 60px;
    height: 44px;
    border-radius: 8px;
`;

const StyledExternalEvents = styled.div<{ isExpanded: boolean }>`
    position: relative;
    width: ${(props) => (props.isExpanded ? "400px" : "100px")};
    height: 736px;
    background: #fcfcfc;
    box-shadow: 0px 4px 16px rgb(0 0 0 / 12%);
    border: 1px solid #f0f2f2;
    border-radius: 8px 0px 0px 8px;
    border-right: none;
    transition: width 0.3s ease;
    overflow: visible;
`;

const StyledGroupCardContainer = styled.div`
    width: 100%;
    background: #f0f2f2 !important;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    margin: 9px;
    margin-left: 18px;
    margin-right: 18px;
`;

const StyledCard = styled.div`
    width: 100%;
    cursor: pointer;
    width: 100%;
    height: 60px;
    background: #515151;
    border-radius: 8px;
    color: #fff;
    display: flex;
    justify-content: space-between;
    padding: 12px;
    align-items: center;
`;

const StyledCardEmptyResult = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 20px;
    text-align: center;
    font-size: 16px;
    color: #404040;

    @media (max-width: 768px) {
        font-size: 14px;
        padding: 10px;
    }

    @media (max-width: 480px) {
        font-size: 12px;
        padding: 5px;
    }
`;

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: 25px;
    right: 25px;
`;

const StyledActivityHeaderDiv = styled.div<{ isExpanded: boolean }>`
    padding: 25px 15px;
    height: 100px;
    display: flex;
    flex-direction: column;
    transition: all 0.3s ease;
    justify-content: space-between;

    @media (max-width: 768px) {
        flex-direction: row;
        justify-content: space-between;
        height: auto;
    }
`;
const StyledToggleButtonContainer = styled.div`
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 20;
    visibility: visible;
`;
const StyledHeaderRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;
const StyledBacklogTitleContainer = styled.div`
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
const StyledBacklogPhraseContainer = styled.div`
    margin-top: 8px;
`;

const StyledBacklogDiv = styled.div`
    height: 540px;
    overflow: auto;
    padding-top: 10px;
`;

const StyledScheduleDiv = styled.div`
    width: 248px;
    height: 48px;
    background: #f0f2f2;
    border: 1px solid #e4e4e4;
    border-radius: 4px;
    display: flex;
    padding: 12px 20px;
    margin: 31px 0 0 33px;
`;

const StyledExtractButton = styled(Button)`
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 110px;
    min-height: 48px;
    padding: 8px 18px 8px 18px;
    border-radius: 24px;
    box-shadow: none;
    color: #8a0538;
    background: transparent;
    border: none;
    margin: 0;
    &:disabled {
        cursor: not-allowed;
        opacity: 1;
        background: #e4e4e4;
        color: #404040;
        border: none;
        > svg {
            fill: #787878;
        }
    }
    > a {
        color: inherit;
        text-decoration: none;
    }
    svg {
        width: 17px !important;
        height: 17px !important;
        fill: #8a0538;
        margin-right: 6px;
    }
    &:hover {
        color: #8a0538 !important;
        background: transparent !important;
        border: none !important;
        > svg {
            fill: #8a0538 !important;
        }
    }
`;

const ToggleExpandButtonRight = styled.button`
    position: absolute;
    top: 50px;
    right: 5px;
    z-index: 20;
    background: transparent;
    border: none;
    cursor: pointer;
    @media (max-width: 768px) {
        position: static;
        margin-left: 10px;
    }
`;

const ToggleExpandButtonCenter = styled.button`
    position: absolute;
    top: 50px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 20;
    background: transparent;
    border: none;
    cursor: pointer;
    @media (max-width: 768px) {
        position: static;
        margin-left: 10px;
    }
`;

const StyledLegendDiv = styled.div`
    display: flex;
    align-items: start;
    justify-content: center;
    flex-direction: column;
    gap: 5px;
`;

const StyledLegendFirstTitle = styled.h1`
    color: #1e1e1e;
    font-weight: 700px;
    font-size: 24px;
`;

const StyledLegendParagraph = styled.p`
    color: #404040;
    font-weight: 400px;
    font-size: 15px;
`;

const StyledLegendHeader = styled.div`
    align-items: center;
`;

const StyledLegendContainer = styled.div`
    width: 100%;
`;

const StyledLegendTab = styled(Tabs)`
    .nav-link {
        background-color: transparent !important;

        border-bottom: 1px solid #e4e4e4;
        border-top: none !important;
        border-left: none !important;
        border-right: none !important;

        font-weight: 400 !important;
        font-family: "Source Sans Pro";
        color: #787878;
        border-color: none !important;

        &:hover,
        &:focus {
            border-top: none !important;
            border-left: none !important;
            border-right: none !important;
        }
    }

    .nav-link.active {
        background-color: transparent !important;
        color: #1e1e1e;
        border-bottom: 2px solid #9654ff;
        border-top: none !important;
        border-left: none !important;
        border-right: none !important;
    }
`;

const StyledLegendIconContainerModal = styled.div`
    overflow-y: scroll;
    height: 460px !important;
`;

const StyledLegendIconContainer = styled.div`
    width: 100%;
    margin: 1rem 0px;

    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 0.5px solid #1e1e1e14;
    padding-bottom: 1rem;
`;

const StyledLegendIconContent = styled.div`
    width: 30%;

    & > svg {
        width: 36px !important;
        height: 36px !important;
    }
`;

const StyledLegendIconLabelContent = styled.div`
    width: 70%;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    & > p {
        font-weight: 400;
        margin: 0px;
        display: table-cell;
        vertical-align: middle;
        padding: 10px;
    }
`;

export {
    StyledScheduleContainer,
    StyledTitleContainer,
    StyledDateButton,
    StyledExternalEvents,
    StyledGroupCardContainer,
    StyledCard,
    StyledCardEmptyResult,
    ButtonWrapper,
    StyledModalLegend,
    StyledSquareLegend,
    StyledLegendTitle,
    StyledBacklogTitle,
    StyledBacklogPhrase,
    StyledActivityHeaderDiv,
    StyledBacklogDiv,
    StyledScheduleDiv,
    StyledExtractButton,
    StyledLegendDiv,
    StyledLegendFirstTitle,
    StyledLegendParagraph,
    StyledLegendHeader,
    StyledLegendContainer,
    StyledLegendTab,
    StyledLegendIconContainerModal,
    StyledLegendIconContainer,
    StyledLegendIconContent,
    StyledLegendIconLabelContent,
    StyledHeaderRow,
    StyledBacklogTitleContainer,
    StyledBacklogPhraseContainer,
    ToggleExpandButtonRight,
    ToggleExpandButtonCenter,
};
